import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import {
  faCheck,
  faDownload,
  faHome,
  faPlus,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Swal from "sweetalert2";
import Table from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { getAllWoDispenserList } from "../../Service/AllWorkOrder";
import { getProductionList } from "../../Service/AllProductionAPI";
import moment from "moment";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";

export default (props) => {
  const [entries, setEntries] = useState([]);
  const history = useHistory();
  //Pagination
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [isLoaded, setisLoaded] = useState(false);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    getDispenserNo(); // Function call to get Installation list
    // eslint-disable-next-line
  }, []);

  const sendData = (data) => {
    console.log("data :-", data);
    history.push({
      pathname: "/serviceModule/field-job",
      state: { data },
    });
  };

  const handlePageChange = async (page) => {
    let selectedPage = page - 1;
    setEntries([]);
    const role = sessionStorage.getItem("role");
    const fkUserId = sessionStorage.getItem("pkUserId");
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const status = ["open"];
    // setisLoaded(true);
    await getAllWoDispenserList(
      selectedPage,
      "field visit",
      fkUserId,
      role,
      headers,
      status
    )
      .then((result) => {
        setisLoaded(false);
        console.log("Get Pagination DispenserNo Result", result.data);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          const totalSize = result.data.pageable.offset;
          entries.map((item, index) => (item.id = totalSize + index + 1));
          console.log("totalSize", totalSize);
          console.log("data", data);
          setEntries(data);
          setTotaloffset(totalSize);
          setTotalCount(result.data.totalElements);

        } else {
          setisLoaded(false);
          swal("Sorry", "Data is not present", "warning");
        }
      })
      .catch((error) => console.error("Error", error));
    console.log("entries", entries);
  };

  const getDispenserNo = async () => {
    const role = sessionStorage.getItem("role");
    const fkUserId = sessionStorage.getItem("pkUserId");
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const status = ["open"];
    setisLoaded(true);
    await getAllWoDispenserList(
      currentPage,
      "field visit",
      fkUserId,
      role,
      headers,
      status
    )
      .then((result) => {
        setisLoaded(false);
        console.log("Work Order field visit Result List", result.data);
        if (result?.data?.content?.length !== 0) {
          const data = result.data.content;
          setEntries(data);
          setPageCount(result.data.totalPages);
          setTotalCount(result.data.totalElements);

        } else {
          setEntries([]);
          setPageCount();
          setTotalCount();
          setisLoaded(false);
        }
      })
      .catch((error) => {
        console.log("Work Order field visit Error", error);
      });
  };

  // const getJobType = (oprationType) => {
  //   // Check if oprationType is one of Rate Change, Time Change, or Date Change
  //   if (oprationType === "Rate Change" || oprationType === "Time Change" || oprationType === "Date Change") {
  //     return "Non-OTP";  // If any of these, it's Non-OTP
  //   } else {
  //     return "OTP";  // Otherwise, it's OTP
  //   }
  // };

  // Adding srno column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));

  // Column heading of installation list
  const columns = [
    { dataField: "id", text: "Id" },
    {
      dataField: "status",
      text: "Status",
      editable: false,
      style: {
        textTransform: "capitalize",
      },
    },
    {
      dataField: "generateUniqueDispenserNo",
      text: "Dispenser Sr No",
      editable: false,
    },
    {
      dataField: "workOrderSerialNo",
      text: "Work Order Sr No",
      editable: false,
    },
    {

      dataField: "oprationType",
      text: "Operation Type",
      editable: false,
    },
    {

      dataField: "dispenserType",
      text: "Dispenser Config",
      editable: false,
    },
    // {
    //   dataField: "jobType",
    //   text: "Job Type",
    //   editable: false,
    //   formatter: (cell, row) => {
    //     return <>{getJobType(row.oprationType)}</>;  // Use the getJobType function to determine jobType
    //   },
    // },
    {
      dataField: "fieldVisitDate",
      text: "Field Visit Date",
      editable: false,
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      },
    },
    {
      dataField: "fieldVisitTime",
      text: "Field Visit Time",
      editable: false,
      formatter: (cell) => {
        return <>{moment(cell, "hh:mm A").format("hh:mm A")}</>;
      },
    },
    {
      dataField: "Action",
      text: "Action",
      editable: false,
      formatter: (_, cell) => {
        return (
          <>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => sendData(cell)}
            >
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              Fill Field Job WO
            </button>
          </>
        );
      },
    },
  ];

  const customTotal = (from, to, size) => (
    <div>
      Showing {from} to {to} of {size} entries
    </div>
  );

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <ToolkitProvider
          keyField="id"
          search={true}
          columns={columns}
          data={entries}
          exportCSV
        >
          {({ baseProps, searchProps, csvProps }) => (
            <Paginator.PaginationProvider
              pagination={Pagination({
                custom: true,
                alwaysShowAllBtns: true,
                totalSize: totalCount,
                paginationTotalRenderer: customTotal,
                onPageChange: (page) => {
                  handlePageChange(page);
                },
              })}
            >
              {({ paginationProps, paginationTableProps }) => (
                <Card>
                  <div className="table-responsive py-2">
                    <Card.Header>
                      <Row>
                        <Col xs={12} md={6} className="py-1">
                          <h5 className="head ">Field Job work-orders </h5>
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          className="d-flex justify-content-md-end py-1"
                        ></Col>
                      </Row>
                    </Card.Header>

                    <Table
                      {...baseProps}
                      {...paginationTableProps}
                      bodyClasses="border-0"
                      rowClasses="border-bottom"
                      classes="table-flush dataTable-table"
                      remote={{ pagination: true }}
                      cellEdit={cellEditFactory({ mode: "click" })}
                      wrapperClasses="table-responsive"
                      headerClasses="header-class"
                    />
                    <Card.Footer>
                      <Row>
                        <Col
                          xs={12}
                          md={6}
                          className="d-flex align-items-center py-1"
                        ></Col>
                        <Col
                          xs={12}
                          md={6}
                          className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                        >
                          <Paginator.PaginationListStandalone
                            {...paginationProps}
                          />
                        </Col>
                      </Row>
                    </Card.Footer>
                  </div>
                </Card>
              )}
            </Paginator.PaginationProvider>
          )}
        </ToolkitProvider>
      )}
    </>
  );
};
